module.exports = __webpack_public_path__ + "img/open_in_new_white_24dp@2x.77b9b0c4.png";